import n from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import v from "./iconfont.es5471.js";
const d = {
  display: "block"
}, x = ({ size: a = 16, useVw: e, useRem: l, color: o, withColor: c, removeClassName: t, disableSSR: p, style: i, ...g }) => {
  const m = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ n.createElement(v, { disableSSR: p }, /* @__PURE__ */ n.createElement("svg", { "data-icon-id": "32px-lianghuagendan", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: e ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (l ? "rem" : "px"), height: e ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (l ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: m, fill: "none", ...g }, /* @__PURE__ */ n.createElement(
    "g",
    {
      className: t ? "" : "32px-éåè·å"
    },
    /* @__PURE__ */ n.createElement(
      "path",
      {
        className: t ? "" : "normal",
        d: "M15.536 4.047a3.77 3.77 0 0 0-4.252 3.739v16.428a3.77 3.77 0 0 0 4.252 3.738l9.076-1.172a3.77 3.77 0 0 0 3.287-3.738v-3.694a.9.9 0 0 0-1.8 0v3.694a1.97 1.97 0 0 1-1.717 1.953l-9.077 1.172a1.97 1.97 0 0 1-2.221-1.953V7.786a1.97 1.97 0 0 1 2.221-1.953l9.077 1.172a1.97 1.97 0 0 1 1.717 1.953v2.92c0 .263-.102.516-.285.704l-3.908 4.037-2.594-2.68a.9.9 0 0 0-1.375.097l-2.778 3.826a.9.9 0 0 0 1.457 1.058l2.148-2.959 2.495 2.578a.9.9 0 0 0 1.294 0l4.554-4.705a2.813 2.813 0 0 0 .792-1.956v-2.92a3.77 3.77 0 0 0-3.287-3.739l-9.076-1.172ZM7.87 7.448a3.77 3.77 0 0 0-3.77 3.77v9.564a3.77 3.77 0 0 0 3.77 3.77h.524a.9.9 0 0 0 0-1.8H7.87a1.97 1.97 0 0 1-1.97-1.97v-9.565a1.97 1.97 0 0 1 1.97-1.969h.524a.9.9 0 0 0 0-1.8H7.87Z",
        fill: c ? r(o, 0, "#262933") : "#262933",
        datafollowfill: c ? r(o, 0, "#262933") : "#262933"
      }
    )
  )));
}, E = x;
export {
  E as default
};
